import { useEffect, useState } from "react";

/**
 * Non-secret runtime config for the SPA, fetched once from the auth-free
 * /web-config endpoint (module-cached). Defaults are SaaS-shaped so the UI
 * renders optimistically; an on-prem install flips `billingEnabled` off after
 * the fetch resolves (a brief, on-prem-only flicker is acceptable).
 */
export interface WebConfig {
  billingEnabled: boolean;
  /** Whether any authenticated user may create their own org (POST /orgs). */
  orgSelfServiceEnabled: boolean;
}

let cached: WebConfig | null = null;

export function useWebConfig(): WebConfig {
  const [cfg, setCfg] = useState<WebConfig>(cached ?? { billingEnabled: true, orgSelfServiceEnabled: true });

  useEffect(() => {
    if (cached) return;
    void fetch("/web-config")
      .then((r) =>
        r.ok ? (r.json() as Promise<{ billingEnabled?: boolean; orgSelfServiceEnabled?: boolean }>) : null,
      )
      .then((j) => {
        cached = {
          billingEnabled: j?.billingEnabled ?? true,
          orgSelfServiceEnabled: j?.orgSelfServiceEnabled ?? true,
        };
        setCfg(cached);
      })
      .catch(() => undefined);
  }, []);

  return cfg;
}
